import { render, staticRenderFns } from "./TeamsPage.vue?vue&type=template&id=653af84b&"
import script from "./TeamsPage.vue?vue&type=script&lang=js&"
export * from "./TeamsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports